<template>
  <v-row justify="center">
    <!-- dialog indicazioni dalla Facoltà di Canonico-->
    <v-dialog v-model="dialogNoteFac" scrollable max-width="900px" persistent>
      <v-card>
        <v-card-title>{{ $t("iscrizione.notaFacolta") }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px">
          <infofacolta :idtesto="varIdTesto" :key="componentKey"></infofacolta>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions class="justify-right">
          <v-checkbox
            v-model="checkBoxNoteFac"
            color="red darken-3"
          ></v-checkbox>
          <strong
            ><b>{{ $t("iscrizione.confermaNota") }}</b></strong
          >
          <v-btn
            :disabled="!checkBoxNoteFac"
            color="orange"
            :right="true"
            :absolute="true"
            class="ma-2"
            @click="
              dialogNoteFac = false;
              checkBoxNoteFac = false;
            "
          >
            {{ $t("chiudi") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- fine dialog-->

    <v-dialog v-model="attivo" persistent>
      <v-form
        ref="form"
        @submit.prevent="onSubmit"
        v-model="valid"
        lazy-validation
      >
        <v-card>
          <!--{{ iscrizione }}-->
          <v-card-title>
            <span class="text-h5">{{ $t("iscrizione.titolo") }} </span>
            <!-- {{ dd_categoria_dinamica }}
            ---------<br />
            {{ iscrizione }}
              {{ iscrizione_store.dati }}<br />
           store: {{ iscrizione_store }}<br />-->
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12">
                  <span class="body-1 font-weight-black">{{
                    $t("iscrizione.domandaOspite")
                  }}</span>
                  <v-icon
                    class="pa-1"
                    v-tooltip="$t('iscrizione.infoCategoria')"
                    color="primary darken-2"
                  >
                    mdi-information-outline
                  </v-icon>
                  <v-radio-group
                    row
                    v-model="iscrizione.flagOspite"
                    :rules="[(v) => v != null || $t('campoObbligatorio')]"
                  >
                    <v-radio
                      name="iscrizione.flagOspite"
                      :label="$t('si')"
                      :value="true"
                      @click="setOspite(true)"
                    ></v-radio>
                    <v-radio
                      name="iscrizione.flagOspite"
                      :label="$t('no')"
                      :value="false"
                      @click="setOspite(false)"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row class="animate__animated animate__bounceInDown">
                <!--unità accademiche-->
                <!--<v-col
                  cols="12"
                  sm="12"
                  v-if="apriForm & !this.iscrizione.flagOspite"
                >
                  <v-select
                    v-model="iscrizione.unita_accademica"
                    :items="dd_unitaaccademiche"
                    @change="checkNote(iscrizione.fac_scelta)"
                    item-text="DECODIF"
                    item-value="CODICENU"
                    v-bind:label="$t('iscrizione.unita_accademica') + '*'"
                    no-data-text="nulla"
                    required
                    return-object
                    :rules="[
                      (v) => !!(v && v.CODICENU) || $t('campoObbligatorio'),
                    ]"
                  >
                  </v-select>
                </v-col>-->
                <!--fine unità accademiche-->
                <v-col cols="12" sm="12" v-if="apriForm">
                  <v-select
                    v-model="iscrizione.fac_scelta"
                    :items="dd_facolta"
                    @change="checkNote(iscrizione.fac_scelta)"
                    item-text="DECODIF"
                    item-value="CODICENU"
                    v-bind:label="$t('iscrizione.facolta')"
                    no-data-text=""
                    required
                    return-object
                    :rules="[
                      (v) => !!(v && v.CODICENU) || $t('campoObbligatorio'),
                    ]"
                  >
                  </v-select>
                </v-col>
              </v-row>

              <v-row
                v-if="apriForm & !this.iscrizione.flagOspite"
                class="animate__animated animate__bounceInDown"
              >
             
                <v-col cols="12" sm="6">
                  <v-select
                    v-model="iscrizione.ciclo_scelto"
                    :items="dd_corsoLaurea_dinamico"
                    v-bind:label="$t('iscrizione.ciclo') + '*'"
                    required
                    :no-data-text="'(' + $t('iscrizione.sceglifacolta') + ')'"
                    item-text="DESCRIZIONEWEB"
                    item-value="CODICENU"
                    return-object
                    :rules="[
                      (v) => !!(v && v.CODICENU) || $t('campoObbligatorio'),
                    ]"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select
                    v-model="iscrizione.spec_scelta"
                    :items="dd_specializzazione_dinamica"
                    required
                    v-bind:label="$t('iscrizione.specializzazione') + '*'"
                    item-text="DECODIFICA"
                    item-value="CODICENU"
                    :no-data-text="'(' + $t('iscrizione.scegliciclo') + ')'"
                    return-object
                    :rules="[
                      (v) => !!(v && v.CODICENU) || $t('campoObbligatorio'),
                    ]"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="2" v-if="parametriGlobali.operatore">
                  <v-select
                    v-model="iscrizione.anno_scelto"
                    :items="durataCiclo_dinamica"
                    v-bind:label="$t('iscrizione.annodicorso') + '*'"
                    required
                    item-text="DECODIF"
                    item-value="CODICENU"
                    :no-data-text="'(' + $t('iscrizione.sceglianno') + ')'"
                    :rules="[(v) => !!v || $t('campoObbligatorio')]"
                    ><template v-slot:prepend-inner>
                      <v-icon
                        class="pa-1"
                        v-tooltip="$t('iscrizione.infoAnnoCorso')"
                        color="primary darken-2"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template></v-select
                  >
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select
                    v-model="iscrizione.tipoIscrizione_scelta"
                    :items="tipo_iscrizione_dinamica"
                    v-bind:label="$t('iscrizione.tipoiscrizione') + '*'"
                    required
                    item-text="DECODIF"
                    item-value="CODICENU"
                    :rules="[(v) => !!v || $t('campoObbligatorio')]"
                  >
                    <template v-slot:prepend-inner>
                      <!--<v-icon
          class="pa-1"
          v-tooltip="$t('iscrizione.infoIscrizione')"
          
          color="primary darken-2"
        >
          mdi-information-outline
        </v-icon>-->
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select
                    v-model="iscrizione.categoria_scelta"
                    :items="dd_categoria_dinamica"
                    v-bind:label="$t('iscrizione.categoria') + '*'"
                    required
                    item-text="DECODIF"
                    item-value="CODICENU"
                    return-object
                    :rules="[
                      (v) => !!(v && v.CODICENU) || $t('campoObbligatorio'),
                    ]"
                    ><template v-slot:prepend-inner>
                      <v-icon
                        class="pa-1"
                        v-tooltip="$t('iscrizione.infoCategoriaORDSTR')"
                        color="primary darken-2"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template></v-select
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer
              ><small>({{ $t("campiObbligatori") }})</small></v-spacer
            >
            <v-btn color="primary darken-1" @click="validazione">
              {{ $t("conferma") }}
            </v-btn>
            <v-btn color="primary darken-1" text @click="chiudi">
              {{ $t("chiudi") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      elevation="24"
      color="primary"
    >
      <b>{{ $t("checkCampiObbligatori") }}</b>
    </v-snackbar>
  </v-row>
</template>

<script>
import api from "@/services/EventService.js";
import infofacolta from "./infofacolta";
export default {
  components: {
    infofacolta,
  },
  name: "anagrafica",

  props: {
    attivo: {
      default: false,
      type: Boolean,
    },
  },
  data: () => ({
    componentKey: 0,
    varIdTesto: null,
    dialogNoteFac: false,
    checkBoxNoteFac: false,
    snackbar: false,
    timeout: 2000,
    iscrizione: {
      unita_accademica: null,
      fac_scelta: null,
      ciclo_scelto: null,
      spec_scelta: null,
      anno_scelto: null,
      tipoIscrizione_scelta: null,
      categoria_scelta: { CODICENU: null, DECODIF: null },
      flagOspite: null,
    },
    dialog: true,
    dd_unitaaccademiche: null,
    dd_facolta: null,
    dd_corsolaurea: null,
    dd_specializzazione: null,
    apriForm: false,
    categoria: [
      { CODICENU: "ORD", DECODIF: "ORDINARIO" },
      { CODICENU: "STR", DECODIF: "STRAORDINARIO" },
    ],
    categoriaOSP: [{ CODICENU: "OSP", DECODIF: "OSPITE" }],
  }),
  methods: {
    dd_facolta_dinamica() {
      if (!this.iscrizione.flagOspite) {
        this.iscrizione.fac_scelta = this.dd_facolta.find(
          (item) => item.CODICENU === this.iscrizione.ciclo_scelto.FACOLTA
        );
      }
    },
    forceRerender() {
      this.componentKey += 1;
    },
    async checkNote(codicefac) {
      if (codicefac.CODICENU == 3) {
        if (this.$i18n.locale == "it") {
          this.varIdTesto = 1;
        } else {
          this.varIdTesto = 2;
        }
        this.forceRerender();
        //this.dialogNoteFac = true;
      }
    },

    async chiudi() {
      if (!this.$refs.form.validate()) {
        await this.$store.dispatch("setStepNoCompletoEvent", 3);
      }
      this.attivo = false;
    },
    async validazione() {
      if (this.$refs.form.validate()) {
        //alert(JSON.stringify(this.iscrizione.ciclo_scelto))
        /* store dei dati
        await this.$store.dispatch("salvaDati", {
          dati: this.iscrizione,
          azione: "setIscrizione"
        });
        */

        //controllo se sono stati cambiati i dati di iscrizione rispetto a quanto già registrato
        if (this.iscrizione_store.dati.fac_scelta.CODICENU != null) {
          if (
            this.iscrizione.ciclo_scelto.CODICENU !=
            this.iscrizione_store.dati.ciclo_scelto.CODICENU
          ) {
            this.$swal
              .fire({
                confirmButtonClass: "btn",

                title: this.$t("iscrizione.cambioIscrizione"),
                icon: "info",
                showCancelButton: false,
                confirmButtonText: "OK",
                cancelButtonText: this.$t("salvaDati.btnAnnulla"),
              })
              .then(() => {});
            await this.$store.dispatch("setStepNoCompletoEvent", 5);
            await this.$store.dispatch("setStepNoCompletoEvent", 6);

            this.corsiScelti.corsi = [];
            this.corsiScelti.seminari = [];
            this.corsiScelti.letture = [];
          }
        }

        //
        this.iscrizione_store.dati = JSON.parse(
          JSON.stringify(this.iscrizione)
        );
        await this.$store.dispatch("setStepCompletoEvent", 3);

        this.attivo = false;
      } else {
        this.snackbar = true;
      }
    },

    //  carico i dati per i dd
    carica_dd: function() {
      api.get("/anagrafiche/unitaaccademiche/").then((r) => {
        this.dd_unitaaccademiche = r.data;
        // ricarico i dati da store, se presenti
        this.iscrizione.unita_accademica = this.dd_unitaaccademiche.find(
          (item) =>
            item.CODICENU ===
            this.iscrizione_store.dati.unita_accademica_scelta.CODICENU
        );
      });
      //.catch();

      api
        .get("/anagrafiche/facolta/")
        .then((r) => {
          this.dd_facolta = r.data;
          // ricarico i dati da store, se presenti
          this.iscrizione.fac_scelta = this.dd_facolta.find(
            (item) =>
              item.CODICENU === this.iscrizione_store.dati.fac_scelta.CODICENU
          );
        })
        .catch();

      api
        .get("/anagrafiche/corsidilaurea/")
        .then((r) => {
          this.dd_corsolaurea = r.data;
          this.dd_corsolaurea.push({ CODICENU: 999, DESCRBREVE: "OSPITE" });
          // ricarico i dati da store, se presenti
          this.iscrizione.ciclo_scelto = this.dd_corsolaurea.find(
            (item) =>
              item.CODICENU === this.iscrizione_store.dati.ciclo_scelto.CODICENU
          );
        })
        .catch();

      api
        .get("/anagrafiche/specializzazioni/")
        .then((r) => {
          this.dd_specializzazione = r.data;
          // ricarico i dati da store, se presenti
          this.iscrizione.spec_scelta = this.dd_specializzazione.find(
            (item) =>
              item.CODICENU === this.iscrizione_store.dati.spec_scelta.CODICENU
          );
        })
        .catch();

      this.iscrizione.flagOspite = this.iscrizione_store.dati.flagOspite;

      if (
        this.iscrizione.flagOspite === true ||
        this.iscrizione.flagOspite === false
      ) {
        this.apriForm = true;
      }

      // carico i dati da store, se presenti
      if (this.iscrizione.flagOspite) {
        this.iscrizione.ciclo_scelto = { CODICENU: 999, DESCRBREVE: "OSPITE" };
        // alert(JSON.stringify(this.iscrizione.ciclo_scelto))
      }

      //this.iscrizione.anno_scelto = this.iscrizione_store.dati.anno_scelto; // modificato dicembre 2022 per impostare di default sempre anno 1
      this.iscrizione.anno_scelto = 1;
      this.iscrizione.tipoIscrizione_scelta = this.iscrizione_store.dati.tipoIscrizione_scelta;
      this.iscrizione.categoria_scelta.CODICENU = this.iscrizione_store.dati.categoria_scelta.CODICENU;
    },
    setOspite(flag) {
      this.iscrizione.flagOspite = flag;
      if (this.iscrizione.flagOspite) {
        this.iscrizione.ciclo_scelto = {
          CODICENU: 999,
          DESCRIZIONEWEB: "OSPITE",
          FACOLTA: 999,
        };
        this.iscrizione.spec_scelta = {
          CODICENU: 999001,
          DECODIFICA: "OSPITE",
        };
        this.iscrizione.anno_scelto = 1;
        this.iscrizione.tipoIscrizione_scelta = "SEMESTRALE";
        this.iscrizione.categoria_scelta = {
          CODICENU: "OSP",
          DECODIF: "OSPITE",
        };
      } else {
        this.iscrizione.fac_scelta = null;
        this.iscrizione.ciclo_scelto = null;
        this.iscrizione.spec_scelta = null;
        this.iscrizione.anno_scelto = 1;
        this.iscrizione.tipoIscrizione_scelta = null;
        this.iscrizione.categoria_scelta = { CODICENU: null, DECODIF: null };
      }

      this.apriForm = true;
    },

    salvaDescrizione(nome) {
      alert(nome);
    },
    //
  },
  mounted: function() {
    this.carica_dd();
  },
  watch: {
    "iscrizione.fac_scelta": function() {
      //this.iscrizione.spec_scelta = null;
    },
    "iscrizione.ciclo_scelto": function() {
      this.dd_facolta_dinamica();

      //alert(JSON.stringify(this.iscrizione.ciclo_scelto.FACOLTA));
    },
  },
  computed: {
    parametriGlobali() {
      return this.$store.state.parametri;
    },
    iscrizione_store() {
      return this.$store.state.iscrizione;
    },
    corsiScelti() {
      return this.$store.state.corsiscelti;
    },
    dd_corsoLaurea_dinamico() {
      if (!this.iscrizione.flagOspite) {
        
        
        let dd = [];
        try {
          if (this.iscrizione.flagOspite) {
            dd = this.dd_corsolaurea.filter(
              (c) => c.FACOLTA === this.iscrizione.fac_scelta.CODICENU
            );
          } else {
            dd = this.dd_corsolaurea.filter(
                (c) => c.FACOLTA === this.iscrizione.fac_scelta.CODICENU
            );
          }
        } catch (e) {
          dd = "";
        }
        return dd;
      } else {
        return  { CODICENU: 999, DESCRIZIONEWEB: "OSPITE" };
      }
    },
    dd_specializzazione_dinamica() {
      if (!this.iscrizione.flagOspite) {
        // let dd = this.dd_corsolaurea.filter((c) => c.FACOLTA === this.fac_scelta);
        let dd = [];
        try {
          dd = this.dd_specializzazione.filter(
            (c) => c.CORSOLAUREA === this.iscrizione.ciclo_scelto.CODICENU
          );
        } catch (e) {
          dd = "";
        }
        return dd;
      } else {
        return { CODICENU: 0, DECODIFICA: "OSPITE" };
      }
    },

    durataCiclo_dinamica() {
      var arr = [];

      try {
        var totale = this.dd_corsolaurea
          .filter((c) => c.CODICENU == this.iscrizione.ciclo_scelto.CODICENU)
          .map((item) => item.DURATA);

        for (var i = 1; i < parseInt(totale) + 1; i++) {
          arr.push({ CODICENU: i, DECODIF: i });
        }
        if (this.iscrizione.flagOspite) {
          arr = { CODICENU: 1, DECODIF: 1 };
        }
      } catch {
        console.log("annozero");
      }

      return arr;
    },
    tipo_iscrizione_dinamica() {
      var arrTipo = [
        { CODICENU: "SEMESTRALE", DECODIF: "SEMESTRALE" },
        { CODICENU: "ANNUALE", DECODIF: "ANNUALE" },
      ];
      var arrTipo2sem = [{ CODICENU: "SEMESTRALE", DECODIF: "SEMESTRALE" }];

      if (this.iscrizione.flagOspite || this.parametriGlobali.semestre == 2) {
        arrTipo = arrTipo2sem;
      }
      /*if (
        this.parametri[0].SEMESTRE == 2 ||
        this.log_tipo_iscrizione == "OSPITE" ||
        this.RinnovoRichiesto.POSISCRIZIONE == 3
      ) {
        arrTipo = arrTipo2sem;
      }*/

      return arrTipo;
    },
    dd_categoria_dinamica() {
      if (!this.iscrizione.flagOspite) {
        return this.categoria;
      } else {
        return this.categoriaOSP;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// Reversed input variant
.v-input--reverse .v-input__slot {
  flex-direction: row-reverse;
  justify-content: flex-end;
  .v-application--is-ltr & {
    .v-input--selection-controls__input {
      margin-right: 0;
      margin-left: 8px;
    }
  }
  .v-application--is-rtl & {
    .v-input--selection-controls__input {
      margin-left: 0;
      margin-right: 8px;
    }
  }
}

// Bonus "expand" variant
.v-input--expand .v-input__slot {
  // justify-content: space-between;
  .v-label {
    display: block;
    flex: 1;
  }
}

.v-label {
  font-size: 20px;
}
</style>
